import React from 'react';
import { svgSprite, Tooltip } from '../../../hybrid/wrappers';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import { t } from '../../../common/components/T';
import { useWidgetTranslates } from '../../../common/utils/utils';
import classnames from 'classnames';
import { generateCompStylers, generateStylers, getStylePropsFunc } from '../../../common/utils/styles';

const Counter = ({ compStyles, data, counterSettings = {} }) => {
    const { stylers, classes } = generateCompStylers(compStyles);
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);

    const length = data?.data?.length;
    const widthDimensions = useWindowDimensions();

    const mobile = widthDimensions < 992;

    const transl = useWidgetTranslates('gridFilter');

    if (!data) {
        return null;
    }
    return Object.keys(data).length > 0 && data.type === 'counter-order' ? (
        <div {...getStyleProps('counterWrapper')}>
            <div {...getStyleProps('adminCounterMainTitle')}>
                <div style={{ paddingRight: '10px' }}>{t('gridHeader-stat', 'Статистика', 'widget', transl, 'gridFilter')}</div>
                <div {...getStyleProps('adminCounterInfo')}>
                    <Tooltip
                        text={t(
                            'gridHeader-CounerTooltip',
                            'Данные зависят от результатов поиска',
                            'widget',
                            transl,
                            'gridFilter'
                        )}
                        compStyle={{
                            inner: {
                                className: mobile ? classes.infoIcon : classes.infoIconNative,
                                ...(mobile
                                    ? {
                                          ...stylers.infoIcon,
                                          top: '-6px',
                                          position: 'relative'
                                      }
                                    : stylers.infoIconNative)
                            }
                        }}
                    >
                        {svgSprite('info-circle', getStyleProps('infoIcon'))}
                    </Tooltip>
                </div>
            </div>
            <div {...getStyleProps('flexRow', 'adminCounterUp')}>
                <div {...getStyleProps('adminCounterLine')} />
                {data.data.map((params, idx) => {
                    const subValueStyles = generateStylers(params?.subValueStyles);
                    const background = mobile ? params.background : 'none';
                    return (
                        <div
                            style={
                                idx === 2 && data.length < 4
                                    ? {
                                          ...stylers.flexRow,
                                          ...stylers.adminCounterItem,
                                          ...stylers.adminCounterItemCenter,
                                          backgroundColor: background,
                                          ...stylers.adminCounterItemCustom
                                      }
                                    : idx === 1
                                    ? {
                                          ...stylers.flexRow,
                                          ...stylers.adminCounterItem,
                                          ...stylers.adminCounterItemRight,
                                          backgroundColor: background,
                                          ...stylers.adminCounterItemCustom,
                                          ...stylers.adminCounterItemRight
                                      }
                                    : {
                                          ...stylers.flexRow,
                                          ...stylers.adminCounterItem,
                                          backgroundColor: background,
                                          ...stylers.adminCounterItemCustom
                                      }
                            }
                            className={
                                idx === 2 && data.length < 4
                                    ? classnames(
                                          classes.flexRow,
                                          classes.adminCounterItem,
                                          classes.adminCounterItemCenter,
                                          classes.adminCounterItemCustom
                                      )
                                    : idx === 1
                                    ? classnames(
                                          classes.flexRow,
                                          classes.adminCounterItem,
                                          classes.adminCounterItemRight,
                                          classes.adminCounterItemCustom,
                                          classes.adminCounterItemRight
                                      )
                                    : classnames(classes.flexRow, classes.adminCounterItem, classes.adminCounterItemCustom)
                            }
                            key={`params${idx}`}
                        >
                            <div
                                style={
                                    !mobile
                                        ? {
                                              ...stylers.adminCounterCase,
                                              ...stylers.adminCounterCaseCustom,
                                              ...(params.iconStyle || {}),
                                              backgroundColor: params?.background
                                          }
                                        : {
                                              ...stylers.adminCounterCase,
                                              ...stylers.adminCounterCaseCustom,
                                              ...(params.iconStyle || {})
                                          }
                                }
                                className={
                                    !mobile
                                        ? classnames(
                                              classes.adminCounterCase,
                                              classes.adminCounterCaseCustom,
                                              params.iconClassName
                                          )
                                        : classnames(
                                              classes.adminCounterCase,
                                              classes.adminCounterCaseCustom,
                                              params.iconClassName
                                          )
                                }
                            >
                                {svgSprite(params.icon, {
                                    style: {
                                        ...{ fill: params?.color },
                                        ...stylers.adminCounterItemIcon,
                                        ...stylers.adminCounterItemIconCustom,
                                        ...params?.styleIcon
                                    },
                                    className: classnames(
                                        classes?.adminCounterItemIcon,
                                        classes?.adminCounterItemIconCustom,
                                        params?.classNameIcon
                                    )
                                })}
                            </div>
                            <div {...getStyleProps('adminCounterCaseRight', 'adminCounterCaseRightCustom')}>
                                <div {...getStyleProps('adminCounterTitle')}>{params.title}</div>
                                <div
                                    className={classes.adminCounterNumber}
                                    style={{
                                        ...subValueStyles,
                                        ...stylers.adminCounterNumber
                                    }}
                                >
                                    {params.value}
                                    {params?.subValue ? (
                                        <div
                                            className={classes.adminCounterNumberSubValue}
                                            style={{
                                                ...stylers.adminCounterNumberSubValue
                                            }}
                                        >
                                            <div>
                                                {t('counter-sum-orders', 'Кол-во заказов', 'widget', transl, 'gridFilter') + ':'}
                                                <span style={{ color: 'var(--darkColor)', marginLeft: '6px' }}>
                                                    {params.subValue}
                                                </span>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    ) : Object.keys(data).length > 0 && data.type === 'counter-tree' ? (
        <div {...getStyleProps('flexRow', 'adminCounter', 'counterWrapper')}>
            <div {...getStyleProps('adminCounterLine')} />
            {counterSettings?.view ? (
                <counterSettings.view {...counterSettings.props}>
                    {data.data.map((params, idx) => {
                        const subValueStyles = generateStylers(params?.subValueStyles);

                        const background = mobile ? params.background : 'none';
                        return (
                            <div
                                style={
                                    idx === 2 && data.length < 4
                                        ? {
                                              ...stylers.flexRow,
                                              ...stylers.adminCounterItemLong,
                                              ...stylers.adminCounterItemCenter,
                                              backgroundColor: background
                                          }
                                        : idx === 1
                                        ? {
                                              ...stylers.flexRow,
                                              ...stylers.adminCounterItemLong,
                                              ...stylers.adminCounterItemRight,
                                              ...(length > 4 ? stylers?.adminCounterItem5 : {}),
                                              backgroundColor: background
                                          }
                                        : {
                                              ...stylers.flexRow,
                                              ...stylers.adminCounterItemLong,
                                              ...(length > 4 ? stylers?.adminCounterItem5 : {}),
                                              ...(data[idx + 1] ? {} : stylers?.adminCounterItemLast),
                                              backgroundColor: background
                                          }
                                }
                                className={
                                    idx === 2 && data.length < 4
                                        ? classnames(
                                              classes.flexRow,
                                              classes.adminCounterItemLong,
                                              classes.adminCounterItemCenter
                                          )
                                        : idx === 1
                                        ? classnames(
                                              classes.flexRow,
                                              classes.adminCounterItemLong,
                                              classes.adminCounterItemRight,
                                              length > 4 ? classes.adminCounterItem5 : {}
                                          )
                                        : classnames(
                                              classes.flexRow,
                                              classes.adminCounterItemLong,
                                              ...(length > 4 ? classes.adminCounterItem5 : {}),
                                              data[idx + 1] ? {} : classes.adminCounterItemLast
                                          )
                                }
                                key={`params${idx}`}
                            >
                                <div
                                    style={
                                        !mobile
                                            ? {
                                                  ...stylers.adminCounterCase,
                                                  ...stylers.adminCounterCaseCustom,
                                                  ...(params.iconStyle || {}),
                                                  backgroundColor: params?.background
                                              }
                                            : {
                                                  ...stylers.adminCounterCase,
                                                  ...stylers.adminCounterCaseCustom,
                                                  ...(params.iconStyle || {})
                                              }
                                    }
                                    className={
                                        !mobile
                                            ? classnames(
                                                  classes.adminCounterCase,
                                                  classes.adminCounterCaseCustom,
                                                  params.iconClassName
                                              )
                                            : classnames(
                                                  classes.adminCounterCase,
                                                  classes.adminCounterCaseCustom,
                                                  params.iconClassName
                                              )
                                    }
                                >
                                    {svgSprite(params.icon, {
                                        style: {
                                            ...{ fill: params?.color },
                                            ...stylers.adminCounterItemIcon,
                                            ...stylers.adminCounterItemIconCustom,
                                            ...params?.styleIcon
                                        },
                                        className: classnames(
                                            classes.adminCounterItemIcon,
                                            classes.adminCounterItemIconCustom,
                                            params?.styleIcon
                                        )
                                    })}
                                </div>
                                <div {...getStyleProps('adminCounterCaseRight', 'adminCounterCaseRightCustom')}>
                                    <div {...getStyleProps('adminCounterTitle')}>{params.title}</div>
                                    <div
                                        className={classes.adminCounterNumber}
                                        style={{
                                            ...stylers.adminCounterNumber,
                                            ...(params.subValue
                                                ? {
                                                      display: 'flex',
                                                      alignItems: 'center'
                                                  }
                                                : {})
                                        }}
                                    >
                                        {params.value}
                                        {params?.subValue && params.subValue !== '0' ? (
                                            <div {...subValueStyles}>
                                                <Tooltip
                                                    text={t(
                                                        'DeletedPartners',
                                                        'Удаленные партнеры',
                                                        'widget',
                                                        transl,
                                                        'gridFilter'
                                                    )}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        {svgSprite(params.subValueIcon, {
                                                            style: {
                                                                width: '15',
                                                                height: '17',
                                                                margin: '0 8.5px 0 6px'
                                                            }
                                                        })}
                                                        {params.subValue}
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </counterSettings.view>
            ) : (
                data.data.map((params, idx) => {
                    const subValueStyles = generateStylers(params?.subValueStyles);

                    const background = mobile ? params.background : 'none';
                    return (
                        <div
                            style={
                                idx === 2 && data.length < 4
                                    ? {
                                          ...stylers.flexRow,
                                          ...stylers.adminCounterItemLong,
                                          ...stylers.adminCounterItemCenter,
                                          backgroundColor: background
                                      }
                                    : idx === 1
                                    ? {
                                          ...stylers.flexRow,
                                          ...stylers.adminCounterItemLong,
                                          ...stylers.adminCounterItemRight,
                                          backgroundColor: background
                                      }
                                    : {
                                          ...stylers.flexRow,
                                          ...stylers.adminCounterItemLong,
                                          backgroundColor: background
                                      }
                            }
                            className={
                                idx === 2 && data.length < 4
                                    ? classnames(classes.flexRow, classes.adminCounterItemLong, classes.adminCounterItemCenter)
                                    : idx === 1
                                    ? classnames(classes.flexRow, classes.adminCounterItemLong, classes.adminCounterItemRight)
                                    : classnames(classes.flexRow, classes.adminCounterItemLong)
                            }
                            key={`params${idx}`}
                        >
                            <div
                                style={
                                    !mobile
                                        ? {
                                              ...stylers.adminCounterCase,
                                              ...stylers.adminCounterCaseCustom,
                                              ...(params.iconStyle || {}),
                                              'background-color': params?.background
                                          }
                                        : {
                                              ...stylers.adminCounterCase,
                                              ...stylers.adminCounterCaseCustom,
                                              ...(params.iconStyle || {})
                                          }
                                }
                                className={
                                    !mobile
                                        ? classnames(
                                              classes.adminCounterCase,
                                              classes.adminCounterCaseCustom,
                                              params.iconClassName
                                          )
                                        : classnames(
                                              classes.adminCounterCase,
                                              classes.adminCounterCaseCustom,
                                              params.iconClassName
                                          )
                                }
                            >
                                {svgSprite(params.icon, {
                                    style: {
                                        ...{ fill: params?.color },
                                        ...stylers.adminCounterItemIcon,
                                        ...stylers.adminCounterItemIconCustom,
                                        ...params?.styleIcon
                                    },
                                    className: classnames(
                                        classes.adminCounterItemIcon,
                                        classes.adminCounterItemIconCustom,
                                        params?.classNameIcon
                                    )
                                })}
                            </div>
                            <div {...getStyleProps('adminCounterCaseRight', 'adminCounterCaseRightCustom')}>
                                <div {...getStyleProps('adminCounterTitle')}>{params.title}</div>
                                <div
                                    className={classes.adminCounterNumber}
                                    style={{
                                        ...stylers.adminCounterNumber,
                                        ...(params.subValue
                                            ? {
                                                  display: 'flex',
                                                  alignItems: 'center'
                                              }
                                            : {})
                                    }}
                                >
                                    {params.value}
                                    {params?.subValue && params.subValue !== '0' ? (
                                        <div {...subValueStyles}>
                                            <Tooltip
                                                text={t('DeletedPartners', 'Удаленные партнеры', 'widget', transl, 'gridFilter')}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    {svgSprite(params.subValueIcon, {
                                                        style: {
                                                            width: '15',
                                                            height: '17',
                                                            margin: '0 8.5px 0 6px'
                                                        }
                                                    })}
                                                    {params.subValue}
                                                </div>
                                            </Tooltip>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    ) : (
        <div {...getStyleProps('flexRow', 'adminCounter', 'counterWrapper')}>
            <div {...getStyleProps('adminCounterLine')} />
            {data?.map((params, idx) => {
                const subValueStyles = generateStylers(params?.subValueStyles);

                return (
                    <div
                        style={
                            idx === 2 && data.length < 4
                                ? {
                                      ...stylers.flexRow,
                                      ...stylers.adminCounterItem,
                                      ...stylers.adminCounterItemCenter,
                                      ...stylers.adminCounterItemCustom,
                                      ...(mobile ? { backgroundColor: params?.background } : {})
                                  }
                                : idx === 1
                                ? {
                                      ...stylers.flexRow,
                                      ...stylers.adminCounterItem,
                                      ...stylers.adminCounterItemRight,
                                      ...stylers.adminCounterItemCustom,
                                      ...(mobile ? { backgroundColor: params?.background } : {})
                                  }
                                : {
                                      ...stylers.flexRow,
                                      ...stylers.adminCounterItem,
                                      ...stylers.adminCounterItemCustom,
                                      ...(mobile ? { backgroundColor: params?.background } : {})
                                  }
                        }
                        className={
                            idx === 2 && data.length < 4
                                ? classnames(
                                      classes.flexRow,
                                      classes.adminCounterItem,
                                      classes.adminCounterItemCenter,
                                      classes.adminCounterItemCustom
                                  )
                                : idx === 1
                                ? classnames(
                                      classes.flexRow,
                                      classes.adminCounterItem,
                                      classes.adminCounterItemRight,
                                      classes.adminCounterItemCustom
                                  )
                                : classnames(classes.flexRow, classes.adminCounterItem, classes.adminCounterItemCustom)
                        }
                        key={`params${idx}`}
                    >
                        <div
                            style={{
                                ...stylers.adminCounterCase,
                                ...stylers.adminCounterCaseCustom,
                                ...(params.iconStyle || {}),
                                ...(!mobile ? { backgroundColor: params?.background } : {})
                            }}
                            className={classnames(classes.adminCounterCase, classes.adminCounterCaseCustom, params.iconClassName)}
                        >
                            {svgSprite(params.icon, {
                                style: {
                                    ...{ fill: params?.color },
                                    ...stylers.adminCounterItemIcon,
                                    ...stylers.adminCounterItemIconCustom,
                                    ...params?.styleIcon
                                },
                                className: classnames(
                                    classes.adminCounterItemIcon,
                                    classes.adminCounterItemIconCustom,
                                    params?.classNameIcon
                                )
                            })}
                        </div>
                        <div {...getStyleProps('adminCounterCaseRight', 'adminCounterCaseRightCustom')}>
                            <div {...getStyleProps('adminCounterTitle')}>{params.title}</div>
                            <div
                                className={classes.adminCounterNumber}
                                style={{
                                    ...stylers.adminCounterNumber,
                                    ...(params.subValue
                                        ? {
                                              display: 'flex',
                                              alignItems: 'center'
                                          }
                                        : {})
                                }}
                            >
                                {params.value}
                                {params?.subValue && params.subValue !== '0' ? (
                                    <div {...subValueStyles}>
                                        <Tooltip
                                            text={t('DeletedPartners', 'Удаленные партнеры', 'widget', transl, 'gridFilter')}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                {svgSprite(params.subValueIcon, {
                                                    width: '15px',
                                                    height: '17px'
                                                })}
                                                <p
                                                    style={{
                                                        marginLeft: '8px'
                                                    }}
                                                >
                                                    {params.subValue}
                                                </p>
                                            </div>
                                        </Tooltip>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
export default Counter;
